import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/centraliser-donnees.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import picturemethodo from "./img/audit.png";
import picturequality from "./img/quality.png";
import RightPicture from "../Section/RightPicture";
import CheckModule from "../Section/CheckModule";
import pictureevol from "./img/ideas.png";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/goal.png";
import html from "./img/html-css-js.png";

class Conseil extends Component {
  render() {
    let title = "Expert Symfony";
    let goto = "En découvrir plus";
    let alt = "test";
    let description = ["Les équipes d'Integral Service sont composés d'experts dans leurs domaines. Avec ",<strong>plus de 10 ans d'expérience en moyenne</strong>," nous vous accompagnons sur vos besoins en terme de conseil, Audit techniques, ou accompagnement.", <br/>,<br/>, "Nous vous proposons également un ", <a href="/startup" title="Conseil pour startup">service de CTO pour entreprise</a>, " afin de vous apporter un conseil fonctionnel et technique adapté à vos besoins."];
    let smalltitle = "Projet et applications";
    let titlemethodo = "Audit technique";
    let descriptionmethodo = [
        "Nous proposons des prestations d'audit technique des applications, sites et API basées sur le framework Symfony.", <br/>, <br/>,"Parce que pour nous, faire un audit nécessite une réelle expertise, nous ne proposons des audit que sur les technologies que nous maîtrisons.", <br/>, <br/>, "Nous délivrons des rapports complets et documentés ainsi que, le cas échéants, un processus qualité pour résoudre les éventuels problèmes soulevés."   
];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";



    let smalltitleevol = "Un conseil avisé grâce à un large éventail d'expériences";
    let titleevol = "Le conseil";
    let descriptionevol = ["Nous proposons des prestations de conseils autour de vos besoins Web et de votre système d'information. Nous accompagnons plusieurs partenaires autour de conseils dans la ",<strong>stratégie du système d'information</strong> ," ainsi que dans la ", <strong>digitalisation de processus métiers</strong>,".",<br/>,<br/>, "Parce que toute activité est différente, nous adaptons nos processus et nos conseils en fonction de votre organisation et vos métiers."
];

    let altevol = "Intégration du portail dans votre système d'informations";



    let smalltitleCheck = "Aide & conseil" ;
    let titleCheck = "Accompagnement";
    let subtitle1Check = "Un accompagnement quotidien";
    let text1Check = ["Votre métier est notre priorité. Nous vous accompagnons pour vous aider dans votre stratégie digitale.", <br/>, <br/>, "Nous vous écoutons donc pour vous aider au mieux dans l'avancement de la digitalisation de vos processus métiers en respectant votre stratéggie de Système d'information." ];
    let pictureCheck = picturequality;
    let altCheck = "La communication";

    return (
      <div className="generic-services">
        <MainPicture title="Une équipe d'experts" description={description} picture={elasticsearch} alt={alt} />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <RightPicture smalltitle={smalltitleCheck} title={titleCheck} description={text1Check} picture={pictureCheck} alt={altCheck} />

      </div>
    );
  }
}

export default Conseil;



// WEBPACK FOOTER //
// ./src/components/Page/Conseil.jsx